import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, FiscalYear, SaveReportFile, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { Observable } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

@Component({
  selector: "circulation-of-goods-report",
  templateUrl: "circulation-of-goods-report.component.html",
  styleUrls: ["circulation-of-goods-report.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CirculationOfGoodsReportComponent extends BaseFormComponent<any> {
  public apiName: string = "InventoryReview";
  public label: string = "گزارش گردش کالا";
  public gridColumns: form_control[] = [];
  public actions: EntityListAction[] = [];
  public entitys: any[];
  constructor(
    private missetup: MisSetupService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
    this._id = __id;
  }
  async ngOnInit() {
    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.reportName = "GetCirculationOfGoodsReport";
    this.pathPreFix = "INV";
    this.apiName = "InventoryReview";
    this.areaName = "Inventory";
    this.loadReports();
    this.setactions();
    super.ngOnInit();
  }

  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال مالی",
      controlType: FormControlTypes.dropdown,
      modelName: "FiscalYearId",
      userClass: "select-shr",
      disabled: false,
      name: "FiscalYearId",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Id",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "از تاریخ",
      controlType: FormControlTypes.datePicker,
      modelName: "StartVoucherDate",
      disabled: false,
      name: "StartVoucherDate",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "تا تاریخ",
      controlType: FormControlTypes.datePicker,
      modelName: "EndVoucherDate",
      disabled: false,
      name: "EndVoucherDate",
      order: 3,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "شعبه",
      controlType: FormControlTypes.dropdown,
      modelName: "BranchId",
      disabled: false,
      name: "BranchId",
      textType: "text",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
      apiName: "Branch/ReadLookUp",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.columns.push(<form_control>{
      label: "انبار",
      controlType: FormControlTypes.dropdown,
      modelName: "WarehouseId",
      disabled: false,
      name: "WarehouseId",
      textType: "text",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
      dataList: this.getWarehouse(),
      apiName: "",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "کد کالا",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "number",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      dataList: null,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "کالا",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "text",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "واحد سنجش",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "number",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      dataList: null,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "مقدار",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "number",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      dataList: null,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "فی",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "number",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      dataList: null,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.gridColumns.push(<form_control>{
      label: "مبلغ",
      controlType: FormControlTypes.textbox,
      modelName: "",
      disabled: false,
      name: "",
      order: 0,
      textType: "number",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      dataList: null,
      apiName: "",
      valueMember: "Key",
      displayMember: "Title",
    });
    this.orignalColumns = this.columns;
  }

  getWarehouse() {
    let list: any[] = [];
    list.push({ Key: "PL", Title: "انبار اصلی" });
    list.push({ Key: "GL", Title: "انبار رستوران" });
    list.push({ Key: "SL", Title: "انبار تالار" });
    list.push({ Key: "DL1", Title: "انبار فست فود" });
    list.push({ Key: "DL2", Title: "انبار کافی شاپ" });
    return list;
  }

  setactions() {
    this.actions = [
      {
        name: "Print",
        disabled: false,
        displayName: "",
        iconName: "icon-print-o",
        apiName: "InventoryReview",
        areaName: this.areaName,
        permission: "CustomPrintGrid",
        children: [
          {
            name: "print",
            disabled: false,
            displayName: "چاپ",
            iconName: "icon-print-o",
            apiName: "InventoryReview",
            areaName: this.areaName,
            permission: "CustomPrintGrid",
          },
          {
            name: "preview",
            disabled: false,
            displayName: "پیش نمایش",
            iconName: "icon-print-o",
            apiName: "InventoryReview",
            areaName: this.areaName,
            permission: "CustomPrintGrid",
          },
          {
            name: "editReport",
            disabled: false,
            displayName: "اصلاح گزارش",
            iconName: "icon-print-o",
            apiName: "InventoryReview",
            areaName: this.areaName,
            permission: "CustomPrintGrid",
          },
          {
            name: "copyReport",
            disabled: false,
            displayName: "تکثیر گزارش",
            iconName: "icon-print-o",
            apiName: "InventoryReview",
            areaName: this.areaName,
            permission: "CustomPrintGrid",
          },
          {
            name: "deleteReport",
            disabled: false,
            displayName: "حذف گزارش",
            iconName: "icon-print-o",
            apiName: "InventoryReview",
            areaName: this.areaName,
            permission: "CustomPrintGrid",
          },
        ],
      },
      {
        name: "isRefreshing",
        disabled: false,
        displayName: "بازخوانی اطلاعات",
        iconName: "icon-refresh-o",
        apiName: "InventoryReview",
        areaName: this.areaName,
        permission: "CustomPrintGrid",
      },
    ];
  }

  onActionClick(action: EntityListAction) {
    if (
      action.name === "print" ||
      action.name === "preview" ||
      action.name === "editReport" ||
      action.name === "copyReport" ||
      action.name === "deleteReport"
    ) {
      this.changeReport(action.name);
    }
    if (action.name === "isRefreshing") {
      this.loadData();
    }
  }

  onFormChange() {
    this.loadData();
  }

  addControl(): void {
    this.setValue("Key", "GL");
    if (this.accountService.authService.currentFiscalYear) {
      this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
      this.setValue("StartVoucherDate", this.accountService.authService.currentFiscalYear.StartDate);
      this.setValue("EndVoucherDate", this.accountService.authService.currentFiscalYear.EndDate);
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.setValue("FiscalYearId", x.Id);
          this.setValue("StartVoucherDate", x.StartDate);
          this.setValue("EndVoucherDate", x.EndDate);
        }
      });
  }
  changeReport(reprtName: string): void {
    if (!this.apiName) return;
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = this.reportName;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.FileName = `${this.reportName}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.SystemKindName = this.pathPreFix;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.SystemKindName = `${this.pathPreFix}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.CategoryName = this.apiName.replace("/", "_");
    if (this.reportList && this.reportList.length > 1) {
      this.dialogService
        .open(
          this.ReportSelectorForm,
          { dataList: this.reportList, currentrow: null, apiName: this.apiName, areaName: this.areaName, label: "انتخاب گزارش" },
          { autoFocus: true, closeOnEscape: false, closeOnClickOutside: false }
        )
        .pipe(take(1))
        .subscribe((model: any) => {
          if (model) {
            saveReportFile = model;
            this.loadData();
          }
        });
      this.currentReport = "print";
      return;
    }
    if (this.reportList && this.reportList.length === 1) {
      saveReportFile = this.reportList[0];
    } else {
      this.reportList = [];
      this.reportList.push(saveReportFile);
    }
    this.loadData();
  }
  loadData() {
    let filter: GridFilter[] = [];
    filter.push({
      Type: "F",
      Filed: "FiscalYearId",
      Value: this.formGroup.get("FiscalYearId").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filter.push({
      Type: "F",
      Filed: "StartVoucherDate",
      Value: this.formGroup.get("StartVoucherDate").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filter.push({
      Type: "F",
      Filed: "EndVoucherDate",
      Value: this.formGroup.get("EndVoucherDate").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    this.httpCommonService
      .GetFilterGrid("InventoryReview/GetCirculationOfGoodsReport", filter)
      .pipe(take(1))
      .toPromise()
      .then((data: any[]) => {
        this.entitys = data;
      });
  }
  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }
}
